import React, {Component} from 'react';
import Modal from 'react-bootstrap-modal';

import 'sass/modals/modalBlacklisted.scss';

import {t} from 'l10n';

class ModalBlacklisted extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        let {show, closeFn, user} = this.props;

        if (!show) return null;

        return (
            <Modal className="modalBlacklisted" show={show} onHide={closeFn}>
                <Modal.Body>
                    <div className="close" onClick={closeFn}/>

                    <p className="text">{t('Sorry, you\'re blocked by %1.', user.nick)}</p>

                    <div className="form">
                        <div className="form-group">
                            <div className="buttons">
                                <a className="close" onClick={closeFn}>{t('Close')}</a>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}

export default ModalBlacklisted;


// WEBPACK FOOTER //
// ./src/components/modals/ModalBlacklisted.js